import React, { useState } from "react";

const API =
  process.env.NODE_ENV === "production"
    ? "https://ecovanta.onrender.com"
    : "http://localhost:5000";

export default function RequestAccessPage() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    company: "",
    industry: "",
    companySize: "",
    message: ""
  });

  const [status, setStatus] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const updateField = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value
    }));
  };

  const submitRequest = async (event) => {
    event.preventDefault();

    try {
      setStatus("Submitting request...");

      const response = await fetch(`${API}/request-access`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ...form,
          interest: "ESG Gap Analysis Pro",
          source: "gap-analysis-upgrade"
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.error || "Unable to submit request.");
      }

      setSubmitted(true);
      setStatus("");
    } catch (error) {
      console.error("Request access failed:", error);
      setStatus(`Request failed: ${error.message}`);
    }
  };

  if (submitted) {
    return (
      <main style={{ maxWidth: "760px", margin: "0 auto", padding: "50px 20px" }}>
        <section
          style={{
            padding: "32px",
            border: "2px solid #0f766e",
            borderRadius: "16px",
            background: "#f8fafc"
          }}
        >
          <h1>Request received</h1>
          <p>
            Thank you. Your request for ESG Gap Analysis Pro has been received.
            The Ecovanta team will follow up with next steps.
          </p>

          <a href="/esg-gap-analysis">Back to Gap Analysis</a>
        </section>
      </main>
    );
  }

  return (
    <main style={{ maxWidth: "760px", margin: "0 auto", padding: "50px 20px" }}>
      <a href="/esg-gap-analysis">← Back to Gap Analysis</a>

      <h1>Unlock ESG Gap Analysis Pro</h1>

      <p>
        Request access to the full ESG Gap Analysis Pro module, including all
        seven ESG dimensions, detailed action plans, roadmap planning, benchmark
        insights, and export features.
      </p>

      <form
        onSubmit={submitRequest}
        style={{
          marginTop: "24px",
          display: "grid",
          gap: "16px"
        }}
      >
        <input
          required
          placeholder="Full name"
          value={form.name}
          onChange={(event) => updateField("name", event.target.value)}
          style={inputStyle}
        />

        <input
          required
          type="email"
          placeholder="Business email"
          value={form.email}
          onChange={(event) => updateField("email", event.target.value)}
          style={inputStyle}
        />

        <input
          required
          placeholder="Company"
          value={form.company}
          onChange={(event) => updateField("company", event.target.value)}
          style={inputStyle}
        />

        <input
          placeholder="Industry"
          value={form.industry}
          onChange={(event) => updateField("industry", event.target.value)}
          style={inputStyle}
        />

        <select
          value={form.companySize}
          onChange={(event) => updateField("companySize", event.target.value)}
          style={inputStyle}
        >
          <option value="">Company size</option>
          <option value="1-50">1–50 employees</option>
          <option value="51-250">51–250 employees</option>
          <option value="251-1000">251–1000 employees</option>
          <option value="1000+">1000+ employees</option>
        </select>

        <textarea
          placeholder="What are your ESG priorities?"
          value={form.message}
          onChange={(event) => updateField("message", event.target.value)}
          rows={5}
          style={{
            ...inputStyle,
            resize: "vertical"
          }}
        />

        {status && <p>{status}</p>}

        <button
          type="submit"
          style={{
            padding: "14px 22px",
            borderRadius: "10px",
            border: "none",
            background: "#0f766e",
            color: "#ffffff",
            fontWeight: 700,
            cursor: "pointer"
          }}
        >
          Request Access
        </button>
      </form>
    </main>
  );
}

const inputStyle = {
  width: "100%",
  padding: "14px",
  borderRadius: "10px",
  border: "1px solid #cbd5e1",
  fontSize: "16px",
  boxSizing: "border-box"
};